'use strict'

cpntMap.set('awe-ac-announcer', {
  data: function() {
    return {
      message: '',
      clearMessageTimeoutId: 0,
      i18n: window.i18n
    }
  },
  
  methods: {
    announce: function(count) {
      if (count === 0) {
        this.message = ''
        return
      }
      
      // Clear any existing message timeout
      if (this.clearMessageTimeoutId) {
        clearTimeout(this.clearMessageTimeoutId)
      }
      
      const message = this.i18n.getString('SUGGESTIONS_AVAILABLE', {count: count})
      this.message = ''
      this.$nextTick(() => {
        this.message = message
        // Clear message after delay to allow screen readers to announce it and enable re-announcements
        this.clearMessageTimeoutId = setTimeout(() => {
          this.message = ''
        }, 1000)
      })
    }
  },
  
  beforeUnmount: function() {
    clearTimeout(this.clearMessageTimeoutId)
  },
  
  template: `
    <div 
      aria-live="polite" 
      aria-atomic="true"
      class="sr-only"
    >{{ message }}</div>
  `
})
